import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DigitizeImg from "../../images/location_new/fold5/img02.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#262032" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Partner with our Mobile App Development Team In New York to
              Digitise Your Business
            </h2>
            <p>
              Positioned at the forefront of New York City's mobile app
              development landscape, we specialise in crafting solutions aimed
              at elevating user experiences to new heights.Our agile methods,
              infallible management, and faultless collaboration converge to
              produce scalable, cutting-edge mobile apps. With a strong emphasis
              on user-centric experiences, we deliver modern quality assurance
              methods, guaranteeing seamless functionality and bug-free
              deployment.
            </p>
            <p>
              TekRevol is synonymous with unwavering quality, delivering
              top-tier apps that epitomise excellence and innovation. Place your
              trust in us for a transformative app experience that sets new
              industry standards.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#262032",
                border: "1px solid #262032",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="app developers nyc"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
